import { action } from 'satcheljs';

/**
 * Action to set the calendar display order
 */
export const setCalendarDisplayOrder = action(
    'setCalendarDisplayOrder',
    (userIdentity: string, calendarId: string) => ({
        userIdentity,
        calendarId,
    })
);
